var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.post.iframe)}}),_c('div',{staticClass:"con-post-content con-post-content-Poll"},[_c('h1',[_vm._v(_vm._s(_vm.post.body))])]),_c('post-tags',{attrs:{"post":_vm.post}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }